import { useState } from 'react';
import { SocialMedia } from './SocialMedia';

export interface ISHARE {
  url: string;
  domain: number;
  language: string;
}

export const Share = ({ url, domain, language }: ISHARE) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const handleMouseEnter = () => {
    setDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    setDropdownVisible(false);
  };

  return (
    <div
      data-testid="share-container"
      className="relative flex-shrink-0"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="flex items-center gap-1 cursor-pointer py-4 sm:pl-8">
        <img
          src="https://assets.clear.in/cleartax/images/1707729371_sharenetwork.svg"
          alt=""
          className="sm:w-6 sm:h-6"
          height={16}
          width={16}
        />
        <div className="text-base text-font-200 sm:hidden font-medium">
          SHARE
        </div>
      </div>
      {isDropdownVisible ? (
        <div
          className={`absolute left-0 right-0 bg-white z-10 flex flex-col justify-center items-center rounded-md`}
          style={{ boxShadow: '0px 0px 4px 0px #1678FB26' }}
        >
          <SocialMedia url={url} domain={domain} language={language} />
        </div>
      ) : null}
    </div>
  );
};
